define('app/sdc/on/scroll/end/disabled/sdc-on-scroll-end-disabled',[],function () {
	return {};
});
